module.exports = {
  __init__: [ 'interactionEvents' ],
  interactionEvents: [ 'type', require('./InteractionEvents') ]
};


// WEBPACK FOOTER //
// ./~/diagram-js/lib/features/interaction-events/index.js